export default __webpack_public_path__ + "static/maticLogo-70a529c3cb038e5ac88b11d3ae833c9c.png";